import { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { ContentApi } from "../../../shared/api/contentApi.js";
import {
    UiDialogRoot,
    UiDialogContent,
    UiDialogTitle,
    UiDialogDescription,
    UiDialogClose,
    UiDialogHeader,
    UiDialogBody,
    UiDialogFooter,
} from "../../../components/ui/ant/Dialog.jsx";
import {
  Button,
  Form,
  Input,
  Select,
  Switch,
  App
} from 'antd';
import { DialogRow } from "./DialogRow.jsx";


export default function ProjectEditDialog({ open, item, onClose, onSaved }) {
    const [systemName, setSystemName] = useState("");
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (!open || !item) return;
        setSystemName(item.systemName || "");
        setName(item.name || "");
        setDescription(item.description || "");
        setError("");
    }, [open, item]);

    const canSubmit = useMemo(
        () => !!item?.id && systemName.trim() && name.trim() && !saving,
        [item?.id, systemName, name, saving],
    );

    const onSubmit = async (e) => {
        e?.preventDefault?.();
        if (!canSubmit) return;

        setSaving(true);
        setError("");

        try {
            let current = item;
            if (systemName.trim() !== (item.systemName || "")) {
                current = await ContentApi.renameProjectSystemName(projectId, versionId, item.id, systemName.trim());
            }

            const updated = await ContentApi.patchItem(projectId, versionId, item.id, {
                name: name.trim(),
                description: description.trim() || null,
            });

            onSaved?.(updated || current);
            onClose?.();
        } catch (e) {
            setError(e?.message || "Не удалось сохранить изменения");
        } finally {
            setSaving(false);
        }
    };

    if (!open || !item) return null;

    return (
        <UiDialogRoot open={open} onOpenChange={(next) => !next && onClose?.()}>
            <UiDialogContent size="md">
                <UiDialogHeader>
                    <div>
                        <UiDialogTitle>Редактировать проект</UiDialogTitle>
                        <UiDialogDescription>ID: {item.id}</UiDialogDescription>
                    </div>
                    <UiDialogClose showIcon />
                </UiDialogHeader>

                <UiDialogBody>
                    {error && (
                        <div className="mb-4 rounded-xl border border-red-300 bg-red-50 text-red-700 p-3 text-sm">
                            {error}
                        </div>
                    )}

                    <Form layout='vertical' className="space-y-4" onSubmit={onSubmit}>
                        <Form.Item label="System Name *" name="systemName">
                            <Input
                                className="input w-full"
                                value={systemName}
                                onChange={(e) => setSystemName(e.target.value)}
                                placeholder="project_ingot"
                                required
                            />
                        </Form.Item>

                        <Form.Item label="Название *" name="name">
                            <Input
                                className="input w-full"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Project Ingot"
                                required
                            />
                        </Form.Item>

                        <Form.Item label="Описание" name="description">
                            <Input.TextArea
                                className="input w-full"
                                rows={3}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder="Описание для UI"
                            />
                        </Form.Item>
                    </Form>
                </UiDialogBody>

                <UiDialogFooter>
                    <Button type="primary" onClick={onSubmit} disabled={!canSubmit} loading={saving}>
                        {saving ? "Сохраняем..." : "Сохранить"}
                    </Button>
                    <Button type="default" onClick={onClose}>
                        Отмена
                    </Button>
                </UiDialogFooter>
            </UiDialogContent>
        </UiDialogRoot>
    );
}

ProjectEditDialog.propTypes = {
    open: PropTypes.bool,
    project: PropTypes.object,
    onClose: PropTypes.func,
    onSaved: PropTypes.func,
};
